import { CommonConstant } from '../../../app.constants';
import { UserService } from '../../../services/user.service';
var PdfViewerHeaderComponent = /** @class */ (function () {
    function PdfViewerHeaderComponent(userService) {
        this.userService = userService;
    }
    PdfViewerHeaderComponent.prototype.ngOnInit = function () {
        if (!this.previousDate && !this.currentDate) {
            this.currentDate = new Date();
            this.previousDate = new Date();
            var period_time = this.period ? this.period : CommonConstant.PERIOD_30_DAYS;
            this.previousDate.setDate(this.previousDate.getDate() - period_time);
        }
    };
    Object.defineProperty(PdfViewerHeaderComponent.prototype, "logoImage", {
        get: function () {
            return this.userService.logoImage;
        },
        enumerable: true,
        configurable: true
    });
    return PdfViewerHeaderComponent;
}());
export { PdfViewerHeaderComponent };



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/pdf-viewer-header/pdf-viewer-header.component.ts.pre-build-optimizer.js